<div class="flex items-center bg-surface-container rounded-full w-full mb-4">
  @for (item of items(); track item.route) {
    <a
      [routerLink]="item.route"
      routerLinkActive="bg-primary-container text-primary shadow-sm "
      [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
      class="static-label-large flex-1 text-center py-3 bg-surface-container text-on-surface-variant rounded-full transition-all cursor-pointer no-underline select-none"
    >
      {{ item.label }}
    </a>
  }
</div>
